import { AlpineData, LivewireData, LivewireMethods } from "@/js/interfaces/Components/alpinejs/User/UserMassAnonymization";
import { createAlpineLivewireComponent } from "@nolikein/typed-alpinejs";

// Generated from the artisan make:alpine command
export default {
    name: 'UserMassAnonymization',
    component: (
        // Component parameters...
    ) => createAlpineLivewireComponent<AlpineData, LivewireData, LivewireMethods>({
        // Component properties ...
        initialized: false,
        users: [],
        selection: new Set(),

        /**
         * Initialize the component
         */
        init() {
            this.$wire.$call('getUserToAnonimize')
                .then(users => {
                    this.users = users;
                    this.initialized = true;
                });
        },

        /**
         * Toggle a user in the "deletion" list
         */
        toggleUser(userId: number): void {
            if (this.selection.has(userId)) {
                this.selection.delete(userId);
            } else {
                this.selection.add(userId);
            }
        },

        /**
         * A mass soft deletion was dispatched.
         */
        onConfirmMassAnonymization(): void {
            this.$wire.$dispatch('perform-mass-anonymization', {
                userIds: Array.from(this.selection),
            });

            this.initialized = false;
        },

        reloadDisplay(): void {
            if (undefined !== this.init) {
                this.init();
            }
        },
    }),
};
